function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBooks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 504.123 504.123",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#324A5E"
    },
    cx: 252.062,
    cy: 252.062,
    r: 252.062
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.505,
    y: 83.102,
    style: {
      fill: "#FF7058"
    },
    width: 54.351,
    height: 165.022
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.28,
    y: 122.092,
    style: {
      fill: "#FFD05B"
    },
    width: 54.351,
    height: 126.425
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.449,
    y: 160.689,
    style: {
      fill: "#84DBFF"
    },
    width: 54.351,
    height: 87.434
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M371.397,394.634H99.249v-69.317h272.542c19.298,0,34.658,15.36,34.658,34.658l0,0 C406.055,379.274,390.695,394.634,371.397,394.634z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M241.034,337.92h157.145c-0.394-0.788-1.182-1.182-1.969-1.969H241.034h155.175 c-0.788-0.788-1.182-1.182-1.969-1.969H241.034V337.92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M241.034,345.797h161.871c-0.394-0.788-0.788-1.182-0.788-1.969H241.034h161.083 c-0.394-0.788-0.788-1.182-1.182-1.969H241.034V345.797z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M241.034,354.068h164.628c0-0.788-0.394-1.182-0.394-1.969H241.034h163.84 c0-0.788-0.394-1.182-0.394-1.969H241.034V354.068z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M241.034,361.945h165.022c0-0.788,0-1.182,0-1.969l0,0H241.034h165.022c0-0.788,0-1.182,0-1.969 H241.034V361.945z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M241.034,369.822H404.48c0-0.788,0.394-1.182,0.394-1.969h-163.84h163.84 c0-0.788,0.394-1.182,0.394-1.969H241.034V369.822z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M241.034,378.092h159.902c0.394-0.788,0.788-1.182,1.182-1.969H241.034h161.083 c0.394-0.788,0.788-1.182,0.788-1.969H241.034V378.092z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M241.034,385.969H394.24c0.788-0.788,1.575-1.182,1.969-1.969H241.034h155.175 c0.788-0.788,1.182-1.182,1.969-1.969H241.034V385.969z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1543F"
    },
    d: "M94.917,390.302h276.48c16.935,0,30.72-13.785,30.72-30.326c0-16.542-13.785-30.326-30.72-30.326 H94.917v-7.877h276.48c21.268,0,38.597,16.935,38.597,38.203s-17.329,38.203-38.597,38.203H94.917V390.302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M409.994,244.185c-0.394-1.575-1.182-2.757,0-3.938H132.726c-18.905,0-34.265,15.36-34.265,34.265 s15.36,34.265,34.265,34.265h277.662c-1.182-1.182-0.788-1.969,0-3.938C396.997,286.72,396.997,262.302,409.994,244.185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4CDBC4"
    },
    d: "M409.994,304.837H133.908c-16.935,0-30.72-13.785-30.72-30.326c0-16.542,13.785-30.326,30.72-30.326 h276.48v-7.877h-276.48c-21.268,0-38.597,16.935-38.597,38.203c0,21.268,17.329,38.203,38.597,38.203h276.48v-7.877H409.994z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACB3BA"
    },
    d: "M235.126,252.455v9.452h166.991c0.788-3.151,1.969-6.302,3.545-9.452H235.126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACB3BA"
    },
    d: "M268.603,279.237h131.938c-0.394-3.151-0.394-6.302,0-9.452H268.603V279.237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACB3BA"
    },
    d: "M205.982,296.566h199.68c-1.575-3.151-2.363-6.302-3.545-9.452H205.982V296.566z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooks);
export default __webpack_public_path__ + "static/media/books.e8812176f809010826731c555e07aa13.svg";
export { ForwardRef as ReactComponent };